//A Form Configuration to add form submit actions to the form
export const actionsForm = {
    key: "actions",
    name: "Actions",
    type: "form",
    fields: [
        {
            key: "actions",
            name: "Actions",
            type: "url",
            label: "URL",
            description: "The URL to call when the form is submitted",
            required: true
        },
        {
            key: "method",
            name: "Method",
            type: "options",
            label: "Method",
            description: "The HTTP method to use when calling the URL",
            required: true,
            options: [
                {
                    text: "GET",
                    value: "GET"
                },
                {
                    text: "POST",
                    value: "POST"
                },
                {
                    text: "PUT",
                    value: "PUT"
                },
                {
                    text: "DELETE",
                    value: "DELETE"
                }
            ]
        },
        {
            key: "format",
            name: "Format",
            type: "options",
            label: "Format",
            description: "The format to use when calling the URL",
            required: true,
            options: [
                {
                    text: "JSON",
                    value: "json"
                },
                {
                    text: "Form Data",
                    value: "form-data"
                }
            ]
        },
        {
            key: "headers",
            name: "Headers",
            type: "composedList",
            label: "Headers",
            description: "The headers to send when calling the URL",
            required: true,
            fields: [
                {
                    key: "header",
                    name: "Header",
                    type: "text",
                    label: "Header",
                    description: "The header to send when calling the URL",
                    required: true
                },
                {
                    key: "value",
                    name: "Value",
                    type: "text",
                    label: "Value",
                    description: "The value of the header to send when calling the URL",
                    required: true
                }
            ]
        },
        {
            key: "status",
            name: "Trigger on stages",
            type: "multipleOptions",
            label: "Trigger on stages",
            description: "Send the request when the form reaches any of these stages",
            required: false,
            options: [
                { text: "Review", value: "review" },
                { text: "Finalized", value: "finalized" }
            ]
        },
    ]
};
